import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import { childVariants } from '../../../framerOptions'
import { useCongress } from '../../../congress/hooks'

export default function EventDetailCard () {
  const { congress } = useCongress()
  return (
   <Container variants={childVariants}>
     <h4>{congress.Name}</h4>
     <p>{congress.Slogan}</p>
     <p>{congress.DateLine}</p>
   </Container>
  )
}

const Container = styled(motion.div)`
  display: inline-block;
  background: #FFF;
  box-shadow: 0 3px 20px rgba(197, 217, 232, 0.5);
  border-radius: 12px;
  width: 100%;
  margin: 1.2rem 0;
  padding: 2rem;
`